module.exports = __webpack_public_path__ + "static/img/logo2.58f55c5c.png";